module.exports = __webpack_public_path__ + "static/media/cylinder2.5df2e46f.svg";